(function () {
  'use strict';
  if (window.Shopify && window.Shopify.designMode) return;
  var studio = 'https://redvelvetstudio.com', platform = 'https://velvt.io';
  var hosts = ['velvt.io', 'www.velvt.io', 'redvelvetstudio.com', 'www.redvelvetstudio.com'];
  var platformPaths = ['/pages/community', '/pages/members', '/pages/messages', '/pages/submit-music'];
  function isPlatform(url) {
    var path = url.pathname.replace(/\/$/, '') || '/';
    if (platformPaths.indexOf(path) !== -1 || path === '/join') return true;
    return path === '/pages/login' && ['members', 'messages', 'invite', 'submit-music', 'document-signing'].indexOf(url.searchParams.get('view')) !== -1;
  }
  function destination(url) {
    if (hosts.indexOf(url.hostname) === -1) return url;
    var onPlatform = url.hostname === 'velvt.io' || url.hostname === 'www.velvt.io';
    if (isPlatform(url)) {
      url.hostname = 'velvt.io'; url.protocol = 'https:';
      if (url.pathname.replace(/\/$/, '') === '/pages/community') url.pathname = '/';
    } else if (onPlatform && url.pathname !== '/') {
      if (url.pathname === '/pages/login' && !url.searchParams.get('view')) {
        url.hostname = 'velvt.io'; url.protocol = 'https:'; url.pathname = '/';
        url.searchParams.set('mode', 'signin');
      } else if (!/^\/(account|customer_authentication|challenge|checkpoint|checkouts|cart)(\/|$)/.test(url.pathname)) {
        url = new URL(url.pathname + url.search + url.hash, studio);
      }
    }
    return url;
  }
  var current = new URL(location.href);
  if (current.searchParams.has('preview_theme_id') || current.searchParams.has('_fd')) return;
  var next = destination(new URL(current.href));
  if (next.href !== current.href) { location.replace(next.href); return; }
  function updateLink(link) {
    var raw = link.getAttribute('href');
    if (!raw || raw.charAt(0) === '#' || link.hasAttribute('download')) return;
    try {
      var url = new URL(raw, location.href);
      if (!/^https?:$/.test(url.protocol)) return;
      var target = destination(new URL(url.href));
      if (target.href !== url.href) link.setAttribute('href', target.href);
    } catch (_) {}
  }
  function scan(root) {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    if (root.matches && root.matches('a[href]')) updateLink(root);
    root.querySelectorAll('a[href]').forEach(updateLink);
  }
  document.addEventListener('DOMContentLoaded', function () {
    scan(document);
    new MutationObserver(function (records) {
      records.forEach(function (record) {
        if (record.type === 'attributes') updateLink(record.target);
        else record.addedNodes.forEach(scan);
      });
    }).observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['href']});
  });
})();

